import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import type { Signal } from '@angular/core';

export interface ChatHistoryEntry {
  id: string;
  session_id: string;
  question: string;
  section: string;
  subTab: string;
  fieldPromptId: string;
  wellId: string;
  timestamp: string;
  messages: any[];
}

@Component({
  selector: 'app-nav-sidebar',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './nav-sidebar.component.html',
  styleUrls: ['./nav-sidebar.component.scss'],
})
export class NavSidebarComponent {
  @Input() sidebarSections: any[] = [];
  @Input() chatHistory: ChatHistoryEntry[] = [];
  @Input() activeHistoryId: string | null = null;
  @Input() activeNavItemId: string | null = null;
  @Input() mobileOpen = false;
  @Input() showNavItems = true; // false for field/prompt-home mode
  @Input() loadingHistory = false;
  @Input() currentUserDisplayName: string = 'Well Engineer';
  @Input() promptHome = false; // true when on prompt selection page
  @Input() hasMetricsAccess!: Signal<boolean>;
  @Input() currentWellId: string | null = null;  // For single well Lessons Learnt
  @Input() selectedWellIds: string[] = [];  // For multi-well Lessons Learnt

  @Output() newChat = new EventEmitter<void>();
  @Output() navItemClick = new EventEmitter<string>();
  @Output() historyClick = new EventEmitter<ChatHistoryEntry>();
  @Output() metricsClick = new EventEmitter<void>();
  @Output() lessonsLearned = new EventEmitter<string | string[]>();  // For Lessons Learnt API call
  @Output() mobileClose = new EventEmitter<void>();

  isNavLeafActive(itemId: string, selectedSection: string, selectedSubTab: string): boolean {
    // Delegate active check to parent via input
    return false; // overridden by parent using isNavLeafActive input
  }

  truncate(q: string): string {
    return q.length > 36 ? q.slice(0, 33) + '…' : q;
  }

  /**
   * Emit Lessons Learnt event with well IDs
   */
  openLessonsLearned() {
    // If we have selected well IDs, use those (multi-well)
    if (this.selectedWellIds && this.selectedWellIds.length > 0) {
      this.lessonsLearned.emit(this.selectedWellIds);
    }
    // Otherwise, if we have a current well ID, use that (single well)
    else if (this.currentWellId) {
      this.lessonsLearned.emit([this.currentWellId]);
    }
  }
}
